
export const CFCDN = 'https://d3do62bx9kig63.cloudfront.net/'
export interface ProductCardType {
    productId : number;
    name:   string;
    description: string;
    cover: string;
    page: string;
    tagLine:string;
    start: string;
}

const productCardData = [
    {
        productId: 32,
        name: "Roller Blinds",
        description:'Transform your space with our versatile roller blinds, featuring light-filtering and block-out options. Seamlessly control light and privacy while elevating your decor with modern designs. Customize your blinds with our range of fabrics and finishes to suit your style. Experience the perfect blend of elegance and functionality with our premium roller blinds.',
        cover: CFCDN+"product-cover/AdobeStock_639886989.jpeg",
        page: "/roller-blinds",
        tagLine: "Enhance homes with durable, stylish window options.",
        start: '97.59'
    },
    {
        productId: 39,
        name: "Roller Blinds Cassette",
        description:'With side channels and a protective housing eliminate gaps, preventing any light leaks.',
        cover: CFCDN+"product-cover/AdobeStock_639886989.jpeg",
        page: "/roller-blinds",
        tagLine: "With side channels and a protective housing eliminate gaps",
        start: '97.59'
    },
    {
        productId: 33,
        name: "Vertical Blinds",
        description:'Vertical blinds are a sleek and practical window treatment option, perfect for large windows and sliding doors. With vertically hanging slats, they offer excellent control over light and privacy by simply tilting the slats or drawing them completely to one side. Available in a variety of materials, colors, and textures, vertical blinds provide a modern and elegant touch to any room while enhancing its functionality.',
        cover: CFCDN+"product-cover/vertical-blinds-cover.jpeg",
        page: "/vertical-blinds",
        tagLine: "Sleek design and lasting durability",
        start: '73.50'
    },
    {
        productId: 34,
        name: 'Roller Shutters',
        description:"Experience comfort and convenience with our advanced window roller shutters. Enjoy superior heat insulation and motorized operation for effortless control. Elevate your home's style and functionality with our premium shutters.",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2022/06/ASB2795-HI-387_42mmSingleLine_rev.webp',
        page: '/roller-shutters',
        tagLine: "Enhanced security and insulation with roller shutters.",
        start: '554.00'
    },
    {
        productId: 36,
        name: 'PVC Plantation Shutters',
        description:'Enhance your space with our elegant and functional plantation shutters. Crafted with meticulous attention to detail, they add sophistication to any room. Enjoy privacy, natural light control, and durability, making them a lasting investment in style and comfort.',
        cover: CFCDN+"product-cover/plantation-shutter-4.jpeg",
        page: "/pvc-plantation-shutters",
        tagLine: "Durable PVC for timeless window elegance.",
        start: '254.55'
    },
    {
        productId: 35,
        name: 'Venetian Blinds',
        description:"Venetian blinds offer a timeless and versatile window treatment solution that suits any decor style. Featuring horizontal slats, these blinds provide excellent control over light and privacy, allowing you to adjust the slats to your desired angle. Available in various materials such as wood and PVC, Venetian blinds combine functionality with aesthetic appeal to enhance any room in your home.",
        cover: CFCDN+"product-cover/venetian-blinds-cover.jpeg",
        page: '/venetian-blinds',
        tagLine: "Classic style and robust performance combined.",
        start: '150.00'
    },
    
    {
        productId: 37,
        name: 'Curtains',
        description:'Explore our versatile curtain collection, featuring sheer and blackout options alongside motorized curtains for added convenience. Elevate your space with elegance and functionality, effortlessly controlling light and privacy while complementing any decor.',
        cover: CFCDN+"product-cover/single-curtain-cover.jpeg",
        page: '/curtains',
        tagLine: "Elegant drapery to enhance any room's decor.",
        start: '518.38'
    },
    {
        productId: 38,
        name: 'Double Curtains',
        description:"Discover our double curtains, combining style and practicality for your window decor needs. With a sheer curtain layer on the outside and a blockout curtain layer on the inside, enjoy optimal light control and privacy. Choose from a variety of elegant designs and colors to effortlessly enhance the ambiance of any room.",
        cover: CFCDN+"product-cover/curtain-cover-3.jpeg",
        page: '/double-curtains',
        tagLine: "Layered elegance and functionality for your windows.",
        start: '1172.88'
    },
    {
        productId: 40,
        name: 'Panel Glide Blinds',
        description:"Panel glide blinds are an ideal choice for large windows and sliding doors, offering a sleek and contemporary look. These blinds feature wide fabric panels that glide smoothly along a track, providing effortless control over light and privacy. Available in a variety of fabrics and colors, panel glide blinds add a modern touch to your home while offering a practical and stylish solution for covering expansive areas.",
        cover: CFCDN+"product-cover/panel-glide-blinds-cover.jpg",
        page: '/panel-glide-blinds',
        tagLine: "Contemporary elegance and effortless control offered.",
        start: '341.03'
    },
    {
        productId: 41,
        name: 'Roman Blinds',
        description:"Roman shades provide a classic and elegant window treatment that complements any decor. When raised, they fold neatly into soft pleats, creating a clean and sophisticated look. Available in a wide range of fabrics, colors, and patterns, Roman shades offer both style and functionality, providing excellent light control and privacy while adding a touch of timeless beauty to your home.",
        cover: CFCDN+"product-cover/roman-shades-cover.jpeg",
        page: '/roman-blinds',
        tagLine: "Timeless sophistication for any room decor.",
        start: '275.36'
    },
    {
        productId: 42,
        name: 'Zebra Blinds',
        description:"Zebra blinds offer a contemporary and stylish solution for window coverings. Featuring alternating sheer and solid fabric stripes, these blinds allow you to easily control light and privacy by aligning the stripes for a full view or offsetting them for a more opaque look. With their sleek design and versatility, zebra blinds add a modern touch to any space while providing optimal light management and privacy.",
        cover: CFCDN+"product-cover/zebra-blinds.jpg",
        page: '/zebra-blinds',
        tagLine: "Versatile light control with a modern flair.",
        start: '339.58'
    },
    {
        productId: 43,
        name: 'Curvers Blinds',
        description:"Curved blinds offer a unique and modern approach to window treatments, combining sleek design with practical functionality. Their gently curved slats create a soft, flowing look that adds a touch of sophistication to any room. Available in a variety of materials and finishes, curved blinds provide excellent light control and privacy while enhancing the aesthetic appeal of your home with their contemporary style.",
        cover: CFCDN+"product-cover/curver-blinds-cover.jpg",
        page: '/curvers-blinds',
        tagLine: "Unique design perfect for stylish spaces.",
        start: '90.00'
    },
    {
        productId: 44,
        name: "Timber Plantation Shutters",
        description:"Discover our elegant timber plantation shutters, crafted in timeless white to suit your preferences. Not just luxurious, they're also environmentally friendly and efficient, helping regulate room temperatures by blocking direct sunlight. Easily adjustable louvres ensure customizable airflow for year-round comfort.",
        cover: CFCDN+"product-cover/timber-shutter.jpg",
        page: '/timber-plantation-shutters',
        tagLine: "Timeless elegance with natural timber craftsmanship.",
        start: '324.55'
    },
    {
        productId: 46,
        name: "Aluminum Plantation Shutters",
        description:"Introducing Highprofile Avenir: an aluminum shutter designed for interiors, resembling timber but with superior durability. With widths up to 1100mm covered by warranty, it's our strongest yet. Finished in a sleek matte powder coat, it adds modern flair to any space.",
        cover: CFCDN+"product-cover/aluminium-shutter.jpg",
        page: '/aluminium-plantation-shutters',
        tagLine: "Sleek aluminum for modern window styling.",
        start: '366.55'
    },
    {
        productId: 47,
        name: "Protecta Zip Awnings",
        description:"Built to withstand weather conditions un-matchable by any other awning or external blind on the Australian market. Wind, rain or sunshine, this system is built to withstand them all. Create additional rooms & private spaces by extending your outdoor living while remaining protected from sun, wind, rain and those pesky insects.",
        cover: CFCDN+"product-cover/zip-cover.jpg",
        page: '/protecta-zip-awning',
        tagLine: "",
        start: '849.12'
    },
    {
        productId: 48,
        name: "Protecta Straight Drop Awnings",
        description:"Great for areas like patios, pergolas and balconies. With optional fixing straps, you have the ability to secure on lower mounting points if and when required. The straight drop is a clever and simple solution making privacy easy.",
        cover: CFCDN+"product-cover/straight-drop.jpg",
        page: '/protecta-straight-drop',
        tagLine: "",
        start: '747.25'
    },
    {
        productId: 49,
        name: "Protecta Deep Channel Awnings",
        description:"Flawless in operation and robust in appearance, the Deep Channel system shares the same aesthetic and functional attributes as the Z3 system, minus the wind resistance technology. Whether you are looking for the simplicity of spring operation, the reliability of crank operation or the high-tech motorised option, all are available. The lockable bottom rail option can also be used for greater security in spring operated systems.",
        cover: CFCDN+"product-cover/deep-channel-cover.jpg",
        page: '/protecta-deep-channel',
        tagLine: "",
        start: '781.21'
    },
    {
        productId: 50,
        name: "Protecta Pivot Arm Awnings",
        description:"A sleek and stylish system adding new functionality and hardware with streamlined front rail, designed to perform both horizontally and vertically. This gives you complete flexibility and style when paired with our compliment heavy-duty flexible joints.",
        cover: CFCDN+"product-cover/pivot-arm-cover.jpg",
        page: '/protecta-pivot-arm',
        tagLine: "",
        start: '747.25'
    },
    {
        productId: 51,
        name: "Protecta Wire Guide Awnings",
        description:"Designed for large openings, Protecta Wire Guide Awnings are sleek and modern in design, and will compliment your properties exterior at an affordable price. Fitted with quality architectural stainless steel fittings, this awning brings an aesthetic appeal while wire cabling suspends and secures the awning.",
        cover: CFCDN+"product-cover/wire-guide-cover.jpg",
        page: '/protecta-wire-guide',
        tagLine: "",
        start: '747.25'
    },
    {
        productId: 52,
        name: "Protecta Multi Stop Awnings",
        description:"With no exposed cords, cleats or wires this system is simple and easy to use. To stop at any location, simply twist the bottom rail to lock into place. The Protecta Multi-Stop is quiet to operate and provides ideal protection against the elements.",
        cover: CFCDN+"product-cover/multi-stop-cover.jpg",
        page: '/protecta-multi-stop',
        tagLine: "",
        start: '747.25'
    },
    {
        productId: 53,
        name: "Protecta XL Awnings",
        description:"Capable of covering external openings including balconies and decks over 4m wide. This robust system is perfect for creating that indoor-outdoor living space. You even have the option of fitting a “weather strip” that slides into the bottom rail blocking those chilly drafts, plus “bug strips” that slip into the side channels.",
        cover: CFCDN+"product-cover/xl-cover.jpg",
        page: '/protecta-xl',
        tagLine: "",
        start: '883.08'
    },
    {
        productId: 54,
        name: "Protecta Auto Arm Awning",
        description:"Curved blinds offer a unique and modern approach to window treatments, combining sleek design with practical functionality. Their gently curved slats create a soft, flowing look that adds a touch of sophistication to any room. Available in a variety of materials and finishes, curved blinds provide excellent light control and privacy while enhancing the aesthetic appeal of your home with their contemporary style.",
        cover: CFCDN+"product-cover/curver-blinds-cover.jpg",
        page: '',
        tagLine: "",
        start: '747.25'
    },
    {
        productId: 57,
        name: "Awning",
        description:"Curved blinds offer a unique and modern approach to window treatments, combining sleek design with practical functionality. Their gently curved slats create a soft, flowing look that adds a touch of sophistication to any room. Available in a variety of materials and finishes, curved blinds provide excellent light control and privacy while enhancing the aesthetic appeal of your home with their contemporary style.",
        cover: CFCDN+"product-cover/curver-blinds-cover.jpg",
        page: '',
        tagLine: "",
        start: ''
    },
    {
        productId: 58,
        name: "Shop Front Awning",
        description:"Discover our top-tier shop front awnings, expertly crafted to enhance your business's appeal and functionality. With a variety of designs and durable materials, our awnings offer protection from the elements while boosting curb appeal. Explore our range today and elevate your storefront effortlessly.",
        cover: CFCDN+"product-cover/shop-front-awning.jpeg",
        page: '/shop-front-awnings',
        tagLine: "",
        start: '980.34'
    },
    {
        productId: 59,
        name: "SHAW Folding Arm Awning",
        description:"Effortlessly merging timeless Italian design with renowned Australian durability, our Folding Arm Awnings provide versatile sun protection. Retract them back to the wall when not in use, or fully extend for optimal shielding from the elements. Featuring Shaw Australia’s exclusive Balteus Arms, our products boast cutting-edge technology for unparalleled longevity.",
        cover: CFCDN+"product-cover/folding-arm-awning.jpg",
        page: '/folding-arm-awnings',
        tagLine: "",
        start: '2338.40'
    },
    
    {
        productId: 66,
        name: 'Residential 42mm Double Line',
        description:"Ideal for domestic and light commercial buildings, our 42mm Double Line Roller Shutter range is crafted with a high-quality aluminium alloy construction with a double line grooved and curved face and is another perfect staple product to have in your range. These shutters are made with a durable, precision roll-formed roller shutter profile and are suitable for a variety of applications.",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2023/02/ASB2795-HI-390_42mmDoubleLine_rev.webp',
        page: '/RS42mmDL',
        tagLine: "Ideal for domestic and light commercial use.",
        start: '554.00'
    },
    {
        productId: 61,
        name: 'Residential 42mm Single Line',
        description:"Crafted with a high-quality aluminium alloy construction, our 42mm Single Line Roller Shutter is the perfect staple product to have in your range. These shutters are made with a durable, precision roll-formed roller shutter profile and are suitable for a variety of domestic and light commercial applications. ",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2022/06/ASB2795-HI-387_42mmSingleLine_rev.webp',
        page: '/RS42mmSL',
        tagLine: "Ideal for domestic and light commercial use.",
        start: '554.00'
    },
    {
        productId: 62,
        name: 'Commerical 36mm',
        description:"Protect properties and businesses with our 36mm Extruded Roller Shutters. These durable, double-wall shutters are perfect for high-security commercial use, guarding against vandalism and intruders, and ensuring peace of mind.",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2023/02/36mm-Extruded-Roller-Shutters.webp',
        page: '/RS36mm',
        tagLine: "Secure Your Store with Heavy-Duty 36mm Roller Shutters.",
        start: '691.00'
    },
    {
        productId: 63,
        name: 'Residential 55m',
        description:"Suitable for wide openings like double doorways up to 4500mm, the 55mm Widespan Roller Shutter is made with a high-quality, precision roll-formed roller shutter profile. Ideal for widespan residential and light commercial applications, its roll-tight design and smooth, curved face profile offer a sleek and modern look and security for your home or business.",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2023/02/CW-Seacliff-Ext-021-final_55mmWidespan_rev.webp',
        page: '/RS55mmDL',
        tagLine: "Ideal for widespan residential and light commercial applications.",
        start: '633.00'
    },
    {
        productId: 64,
        name: 'Commerical 50mm Extrude Vision',
        description:"Perfect for commercial and industrial grade applications, including shopping centres and carparks, our 50mm Extruded Vision Roller Shutter is designed with approximately 20% vision and ventilation perforations. This, combined with a high-quality, strong aluminium alloy construction, makes this shutter the perfect blend of visibility, airflow and security. ",
        cover: 'https://wpstaq-ap-southeast-2-media.s3.amazonaws.com/cwproducts/wp-content/uploads/media/2023/02/50mm-Extruded-Vision-Roller-Shutters.webp',
        page: '/RS50mmEx',
        tagLine: "Provides 20% vision and ventilation perforations.",
        start: '691.00'
    },
    {
        productId: 60,
        name: 'Service',
        description:"",
        cover:'',
        page: '',
        tagLine:'',
        start:''
    },
    {
        productId: 30,
        name: 'Miscellaneous Cost',
        description:"",
        cover:'',
        page: '',
        tagLine:'',
        start:''
    },
    {
        productId: 28,
        name: 'Parts/Components',
        description:"",
        cover:'',
        page: '',
        tagLine:'',
        start:''
    },
]



export const mainPageIndoorSelection = productCardData.filter((entry) => [32,36,37,34].indexOf(entry.productId) > -1) 
export const Blinds = productCardData.filter((entry) => [32,33,35,40,41,42,43].indexOf(entry.productId) > -1) 
export const BlindsCartOption = productCardData.filter((entry) => [32,33,35,39,40,41,42,43].indexOf(entry.productId) > -1)
export const Plantations = productCardData.filter((entry) => [36,44,46].indexOf(entry.productId) > -1) 
export const RollerShutters = productCardData.filter((entry) => [66,61,62,63,64].indexOf(entry.productId) > -1) 
export const Curtains = productCardData.filter((entry) => [37,38].indexOf(entry.productId) > -1) 
export const Awning = productCardData.filter((entry) => [47,48,50,51,58,59].indexOf(entry.productId) > -1) 
export const AwningCartOption = productCardData.filter((entry) => [47,48,50,51,52,57,58,59].indexOf(entry.productId) > -1) 
export const leftPanels = productCardData.filter((entry) => [32,33,36,37,35].indexOf(entry.productId) > -1) 
export const rightPanels = productCardData.filter((entry) => [36,37,35].indexOf(entry.productId) > -1) 
export const popularIndoor = productCardData.filter((entry) => [32,33,37].indexOf(entry.productId) > -1) 
export const headerAwnings = productCardData.filter((entry) => [47,48].indexOf(entry.productId) > -1)
export const headerBlinds = productCardData.filter((entry) => [32,33].indexOf(entry.productId) > -1)
export const headerCurtains = productCardData.filter((entry) => [37,38].indexOf(entry.productId) > -1)
export const headerPS = productCardData.filter((entry) => [36,44].indexOf(entry.productId) > -1)
export const headerRS = productCardData.filter((entry) => [66,62].indexOf(entry.productId) > -1)
export const headerListAwnings = productCardData.filter((entry) => [47,48,51,58,59].indexOf(entry.productId) > -1)
export const headerListBlinds = productCardData.filter((entry) => [32,33,35,41].indexOf(entry.productId) > -1)
export const justRollerShutter = productCardData.filter((entry) => [34].indexOf(entry.productId) > -1)
export const Others =  productCardData.filter((entry) => [60,30,28].indexOf(entry.productId) > -1)
export const getProductByID  = (id:number) =>{
    return productCardData.find((entry) => entry.productId == id) 
}
export const popularAwning = productCardData.filter((entry) => [47,48,51].indexOf(entry.productId) > -1) 
export const popularWindow= productCardData.filter((entry) => [32,34,36].indexOf(entry.productId) > -1) 
export interface productListItem {
    id:number;
    name:string;
    cover:string;
    products: ProductCardType[];
    description: string;
    backdrop:string;
}
export const blindList =  [
    {
        id:0,
        name: 'Blinds',
        cover: CFCDN+'product-category-cover/blinds-cover.jpg',
        products:Blinds,
        description:"Discover our stylish and functional blinds collection, designed to enhance the beauty and privacy of your home with ease. From modern to classic designs, find the perfect fit for every room and enjoy superior light control and energy efficiency.",
        backdrop: CFCDN+"Carousel/explore-roller-blinds.jpeg",
    },
    {
        id:1,
        name: 'Plantation Shutters',
        cover: CFCDN+'product-category-cover/plantation-cover.jpeg',
        products:Plantations,
        description:"Plantation shutters combine timeless elegance with practical functionality. Their adjustable louvers offer versatility in light control and privacy, while their high-quality materials ensure durability and timeless beauty. Whether you prefer traditional or contemporary styles, plantation shutters provide a stylish and practical solution for enhancing your windows' aesthetic appeal.",
        backdrop: CFCDN+"Carousel/AdobeStock_805337772.jpeg",
    },
    
    {
        id:4,
        name: 'Roller Shutters',
        cover: CFCDN+'product-category-cover/roller-shutter-cover.jpg',
        products:RollerShutters,
        description:"Crafted from durable aluminum, roller shutters offer reliable and low-maintenance window coverage. With smooth operation, they provide effortless control over light, privacy, and security for your home. Available in various colors and finishes, roller shutters seamlessly complement any decor, making them a stylish and practical choice for window enhancement.",
        backdrop: CFCDN+"product-cover/roller-shutter-with-person.jpeg",
    },
    {
        id:3,
        name: 'Awnings',
        cover: CFCDN+'product-category-cover/awning-cover.jpg',
        products:Awning,
        description:"Discover the perfect blend of elegance and functionality with our premium awnings. Expertly designed to offer superior shade and weather protection, our awnings transform your patio, deck, or garden into a refined, year-round sanctuary. Choose from our range of manual and motorized options to find the perfect addition to your outdoor living space.",
        backdrop: CFCDN+"Carousel/AdobeStock_696057326.jpeg",
    },
    {
        id:2,
        name: 'Curtains',
        cover: CFCDN+'product-category-cover/curtains-cover.jpg',
        products:Curtains,
        description:"Curtains are a versatile addition to any room, offering both style and practicality. Available in a variety of fabrics, colors, and designs, curtains allow you to personalize your space and create the desired ambiance. Whether you opt for lightweight sheers to let in soft, diffused light or heavy drapes for added privacy and insulation, curtains effortlessly enhance the decor of your home. From adding a pop of color to providing a finishing touch, curtains remain a timeless choice for dressing up your windows.",
        backdrop: CFCDN+"product-category-cover/curtain-cover-1.jpeg",
    }

] as productListItem[];

export interface CategoryRoute{
    data: ProductCardType[];
    title: string;
    cover: string;
    description: string;
}
export const toAwning = {data:blindList[3]?.products,title:blindList[3]?.name,cover:blindList[3]?.backdrop,description:blindList[3]?.description} as CategoryRoute
export const toBlind = {data:blindList[0]?.products,title:blindList[0]?.name,cover:blindList[0]?.backdrop,description:blindList[0]?.description}as CategoryRoute
export const toCurtain = {data:blindList[4]?.products,title:blindList[4]?.name,cover:blindList[4]?.backdrop,description:blindList[4]?.description}as CategoryRoute
export const toRollerShutter = {data:blindList[2]?.products,title:blindList[2]?.name,cover:blindList[2]?.backdrop,description:blindList[2]?.description}as CategoryRoute
export const toPlantation ={data:blindList[1]?.products,title:blindList[1]?.name,cover:blindList[1]?.backdrop,description:blindList[1]?.description}as CategoryRoute
